import { render, staticRenderFns } from "./ConfirmDeletionModal.vue?vue&type=template&id=4910e88e&scoped=true&"
import script from "./ConfirmDeletionModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeletionModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmDeletionModal.vue?vue&type=style&index=0&id=4910e88e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4910e88e",
  null
  
)

export default component.exports